<template>
  <div class="navbar-container d-flex content align-items-center">
    <ul class="nav navbar-nav d-xl-none-icon">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <h4 class="ml-75 pt-25 mb-0">
      منوتِک
    </h4>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-Toggler />
      <div @click="logout" class="pointer mr-75 ml-75">
        <feather-icon icon="LogOutIcon" size="21" />
      </div>
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BButton, BModal, VBModal } from 'bootstrap-vue';
import DarkToggler from './components/DarkToggler.vue';
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BLink,
    BNavbarNav,
    DarkToggler,
    BButton,
    BModal,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  methods: {
    logout() {
      this.$auth.logout().then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>

<style>
@media (min-width: 1300px) {
  .d-xl-none-icon {
    display: none !important;
  }
}
</style>